import { render, staticRenderFns } from "./HetLeerhuis.vue?vue&type=template&id=227c9b0b&"
import script from "./HetLeerhuis.vue?vue&type=script&lang=js&"
export * from "./HetLeerhuis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports